const style = {
  insightsFilters__checkbox_checked: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
};

export default style;
